import * as api from "@/api/williams/testEvents";
import { TestEventStatus } from "@/api/williams/testEvents";
import { useDefaultEvent } from "./useDefaultEvent";
import { usePinTestEvent } from "./usePinTestEvent";
import { useQueryClient } from "react-query";
import { useSaveTestEvent } from "./useSaveTestEvent";
import { v4 as uuid } from "uuid";
import { queryKeys } from "../../queryKeys";

export function useDuplicateTestEvent() {
  const client = useQueryClient();
  const save = useSaveTestEvent();
  const defaults = useDefaultEvent();
  const pin = usePinTestEvent();

  return async function duplicate(id: string) {
    const event = await api.getTestEventById(id);

    const duplicate = {
      id: uuid(),
      number: defaults.data?.number ?? "",
      description: `Duplicate of ${event.number}`,
      locked: false,
      owner: defaults.data?.owner,
      project: event.project,
      testEventDate: new Date().toISOString().substring(0, 10),
      status: TestEventStatus.New,
      contractorId: event.contractorId,
      supervisor: event.supervisor,
      weldingSpecialistId: event.weldingSpecialistId,
      tests: event.tests,
      welders: event.welders,
      welderTests: [],
    };

    const response = await save.mutateAsync(duplicate);
    pin.mutate(response.id);

    // Add duplicate to the cache.
    client.setQueryData(queryKeys.testEvent.single(response.id), response);
  };
}
